import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { APIService, ModelCreatePresignedURLInput } from 'src/app/API.service';
import { AccountSchemaDataService } from '../../services/account-schema-data.service';

@Component({
  selector: 'app-account-schema-bulk-import',
  templateUrl: './account-schema-bulk-import.component.html',
  styleUrls: ['./account-schema-bulk-import.component.css'],
})
export class AccountSchemaBulkImportComponent implements OnInit {
  files: string[] = [];
  fileUrl: string = '';
  hasError: boolean = false;
  loading: boolean = false;
  csvTemplateUrl: string = `https://cf-invoices-storage74835-dev.s3.eu-central-1.amazonaws.com/csv/account-schema-bulk-import-template-v1.csv`;

  constructor(
    private snackBar: MatSnackBar,
    private apiService: APIService,
    private http: HttpClient,
    private schemaDataService: AccountSchemaDataService,
    private dialogRef: MatDialogRef<AccountSchemaBulkImportComponent>
  ) {}

  ngOnInit(): void {}

  async getPresignedUrl(file: any) {
    this.hasError = false;
    const data: ModelCreatePresignedURLInput = {
      originalFileName: file.name,
      profile: 'bulkUpload',
      action: 'upload',
    };
    this.apiService
      .CreatePresignedURL(data)
      .then((response: any) => {
        this.uploadFile(response.url, file);
        this.fileUrl = response.url.split('?')[0];
      })
      .catch((err) => console.log(err));
  }

  uploadFile(url: string, file: any) {
    const headers = new HttpHeaders();
    headers.set('Content-Type', 'multipart/form-data');
    this.http.put(url, file.rawFile, { headers }).subscribe(
      () => {},
      (error) => console.error('File upload error:', error)
    );
  }

  async addCsv() {
    this.loading = true;
    const userID = localStorage.getItem('userID') || '';
    try {
      const response: any = await this.schemaDataService.bulkImport(this.fileUrl);
      if (response?.result?.toLowerCase() === 'failed') {
        this.hasError = true;
        this.snackBar.open(
          response?.message || 'Bulk import failed',
          '',
          { duration: 5000, panelClass: ['white-snackbar'] }
        );
      } else {
        // Refresh the schema list so newly imported rows show up
        await this.schemaDataService.initializeData(userID).catch(() => {});
        this.dialogRef.close(true);
        this.snackBar.open('Bulk file successfully added', '', {
          duration: 5000,
          panelClass: ['white-snackbar'],
        });
      }
    } catch (err) {
      // AppSync/Lambda may still be processing even if the request timed out.
      // Refresh and inform the user so they can verify.
      console.log(err);
      await this.schemaDataService.initializeData(userID).catch(() => {});
      this.dialogRef.close(true);
      this.snackBar.open(
        'Import is still processing. Please refresh in a moment to see the latest schemas.',
        '',
        { duration: 6000, panelClass: ['white-snackbar'] }
      );
    } finally {
      this.loading = false;
    }
  }
}
